export default {
  title: 'Inventario',
  'menu.transferItems': 'Transferir items',
  'table.name': 'Nombre',
  'table.availableAmount': 'Cantidad disponible',
  'table.totalAmount': 'Cantidad general',
  'table.active': 'Activo',
  'table.status.critical': 'Crítico',
  'table.status.warning': 'Alerta',
  'table.status.normal': 'Normal',
  'table.status.noValues': 'Sin valores de volumen crítico o alerta registrados',
  'actions.viewDetails': 'Ver detalles',
  'actions.edit': 'Editar',
  'actions.transfers': 'Movimientos',
  'actions.qrCode': 'Código QR',
  'actions.remove': 'Eliminar',
  'tabs.details': 'Detalles',
  'tabs.transfersHistory': 'Historial de movimientos',
  'tabs.userStocks': 'Inventario por usuario',
  'tabs.placeStocks': 'Inventario por local',
  'tabs.qrCodes': 'Códigos QR',
  'transfersHistory.title': 'Historial de movimientos',
  'transfersHistory.table.date': 'Fecha',
  'transfersHistory.table.doneBy': 'Hecho por',
  'transfersHistory.table.operationType': 'Tipo de operación',
  'transfersHistory.table.amount': 'Cantidad',
  item: 'Item',
  'transfersHistory.table.origin': 'Origen',
  'transfersHistory.table.destination': 'Destino',
  'transfersHistory.operation.addToGeneral': 'Agregar al inventario general',
  'transfersHistory.operation.removeGeneralStock': 'Remover del inventario general',
  'transfersHistory.operation.setGeneralStock': 'Ajustar valor total del inventario general',
  'transfersHistory.operation.transferFromGeneralToUser': 'Transferir del inventario general al usuario',
  'transfersHistory.operation.transferFromUserToGeneral': 'Transferir del usuario al inventario general',
  'transfersHistory.operation.transferFromGeneralToPlace': 'Transferir del inventario general a un local',
  'transfersHistory.operation.transferFromPlaceToGeneral': 'Transferir del local al inventario general',
  'transfersHistory.operation.selfUse': 'Uso del usuario',
  'transfersHistory.generalStock': 'Inventario general',
  'userStocks.title': 'Historial de transferencias',
  'userStocks.table.user': 'Usuario',
  'userStocks.table.amount': 'Cantidad',
  'placeStocks.title': 'Historial de transferencias',
  'placeStocks.table.place': 'Local',
  'placeStocks.table.amount': 'Cantidad',
  'details.availableAmount': 'Cantidad disponible',
  'details.totalAmount': 'Cantidad general',
  'details.status': 'Estado',
  'details.status.active': 'Activo',
  'details.status.inactive': 'Inactivo',
  'qrcodes.noQrCode': 'Ningún código QR encontrado',
  'operationType.addToGeneral': 'Agregar al inventario general',
  'operationType.removeGeneralStock': 'Remover del inventario general',
  'operationType.setGeneralStock': 'Ajustar valor total del inventario general',
  'operationType.transferFromGeneralToUser': 'Transferir del inventario general al usuario',
  'operationType.transferFromUserToGeneral': 'Transferir del usuario al inventario general',
  'operationType.transferFromGeneralToPlace': 'Transferir del inventario general al local',
  'operationType.transferFromPlaceToGeneral': 'Transferir del local al inventario general',
  'operationType.selfUse': 'Consumo propio'
}
